<div
  class="tag flex--inline flex--middle align-center font-label-small nowrap"
  [ngClass]="{
    'medium-type font-body-2 ps-xsmall-x rounded-medium ': SiteTheme === FinnairTheme.LEGACY,
    'border-rounded-chip': roundingStyle() === TagRoundingStyle.CHIP,
    'tag-curve-left': roundingStyle() === TagRoundingStyle.CURVE_LEFT,
    'tag-curve-right': roundingStyle() === TagRoundingStyle.CURVE_RIGHT,
    'grey-200-bg surface-disabled grey-600-text text-icon-disabled-text':
      SiteTheme === FinnairTheme.LEGACY && disabled(),
  }"
  [class]="classMapping()"
>
  <ng-content />
</div>
